import { render, staticRenderFns } from "./A6.vue?vue&type=template&id=e2205ff2&"
import script from "./A6.vue?vue&type=script&lang=ts&"
export * from "./A6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports